export default function({ res }) {
  return res?.setHeader('Cross-Origin-Opener-Policy', 'same-origin')
}